export type VideoSource =
  | { kind: "youtube"; id: string }
  | { kind: "vimeo"; id: string; hash?: string }
  | { kind: "file"; src: string };

const YOUTUBE_ID = /^[\w-]{11}$/;
const VIMEO_ID = /^\d+$/;
const VIMEO_HASH = /^[\da-f]+$/i;

const youtube = (id: string | null | undefined): VideoSource | null =>
  id && YOUTUBE_ID.test(id) ? { kind: "youtube", id } : null;

export function parseVideoUrl(value: string): VideoSource | null {
  let url: URL;
  try {
    url = new URL(value.trim());
  } catch {
    return null;
  }
  if (url.protocol !== "https:" && url.protocol !== "http:") return null;

  const host = url.hostname.replace(/^(www\.|m\.)/, "");
  const segments = url.pathname.split("/").filter(Boolean);

  if (host === "youtu.be") return youtube(segments[0]);
  if (host === "youtube.com") {
    return url.pathname === "/watch" ? youtube(url.searchParams.get("v")) : null;
  }
  if (host === "vimeo.com") {
    const index = segments.findIndex((segment) => VIMEO_ID.test(segment));
    if (index === -1) return null;
    const hash = segments[index + 1] ?? url.searchParams.get("h");
    return {
      kind: "vimeo",
      id: segments[index],
      ...(hash && VIMEO_HASH.test(hash) ? { hash } : {}),
    };
  }
  if (/\.(mp4|webm)$/i.test(url.pathname)) return { kind: "file", src: url.href };

  return null;
}

export function getVideoEmbedUrl(source: Exclude<VideoSource, { kind: "file" }>): string {
  if (source.kind === "youtube") return `https://www.youtube-nocookie.com/embed/${source.id}`;
  return `https://player.vimeo.com/video/${source.id}${source.hash ? `?h=${source.hash}` : ""}`;
}
